// ©2024 Austin App House. All rights reserved.
import React, {useState} from 'react';
import {connect} from 'react-redux';
import {toggleSecondModalClose} from '../../storage/actions/modalsActions';
import Loader from '../dashboard/common/Loader';

const ExplanationDeactivationModal = ({
                                          toggleSecondModalClose,
                                          returnExplanation,
                                          title,
                                          modalState,
                                          isCloseAvailable = false,
                                      }) => {
    const [message, setMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);

    const onSubmit = () => {
        returnExplanation(message);
        setMessage('');
        setShowLoader(true);
    };

    const onToggle = () => {
        if (isCloseAvailable && !showLoader) toggleSecondModalClose('explanationDeactivationModal', true);
    };

    return (
        <div className={`modal_block dashboard-modal dashboard-modal--centered certification_modal ${modalState.isOpen ? 'showed' : ''}`}>
            <div className="modal_container narrow_modal">
                <div className="inner_container">
                    <span className="filter_shadow top_shadow"></span>

                    <div className="modal_head">
                        <div className="modal_title">{title}</div>
                        <div className="modal_subtitle">
                            <p>Deactivating your account will prevent you from receiving work.</p>
                        </div>
                        {isCloseAvailable && (
                            <button
                                className="close_btn icon_close"
                                aria-label="close"
                                onClick={() => toggleSecondModalClose('explanationDeactivationModal', true)}
                            ></button>
                        )}
                    </div>

                    <div className="modal_body">
                        {showLoader ? (
                            <div className="flex-box flex-center" style={{padding: '40px', color: 'black'}}>
                                <Loader color="black"/>
                            </div>
                        ) : (
                            <div className="form_section">
                                <div className="field_column with_spacing">
                                    <div className="field_name">
                                        <label htmlFor="reason_to_deactivate">Reason (optional)</label>
                                    </div>
                                    <br/>
                                    <div className="field_block">
                                        <textarea
                                            id="reason_to_deactivate"
                                            name="reason_to_deactivate"
                                            placeholder="Type here..."
                                            value={message}
                                            onChange={({target}) => setMessage(target.value)}
                                            maxLength="500"
                                            rows={6}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <span className="filter_shadow bottom_shadow"></span>
                </div>

                <div className="modal_footer">
                    <button
                        className="standard_btn dark_btn"
                        aria-label="cancel"
                        onClick={() => toggleSecondModalClose('explanationDeactivationModal', true)}
                    >
                        Cancel
                    </button>
                    <button
                        className="standard_btn light_btn"
                        aria-label="Submit"
                        onClick={onSubmit}
                        disabled={showLoader}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    modalState: state.modalState.explanationDeactivationModal,
});

export default connect(mapStateToProps, {toggleSecondModalClose})(ExplanationDeactivationModal);